import React from 'react';
import { Menu } from 'antd';
import {FaTshirt} from "react-icons/fa"
import {HiPhotograph} from "react-icons/hi"
import {BiText} from "react-icons/bi"

const ActivateSetting=()=>{
 if(document.getElementById('shirtSettingsShrink')){
  document.getElementById('shirtSettingsShrink').id='shirtSettings';
 }
}

const LeftSideNavbar = (props) => {
    const ownProps=props.props;
    return (<div>
        <Menu
          // defaultSelectedKeys={[ownProps.designer.activeMenuTab]}
          defaultSelectedKeys={'shirtSettings'}
          mode="inline"
          theme="dark"
          style={{overflow:'hidden'}}
        >
         <Menu.Item onClick={(e)=>{ownProps.onMenuKeyChange(e.key);ActivateSetting();}} key="shirtSettings" style={{width:"100%",padding:"10px",justifyContent:"center",margin:"0"}} icon={<FaTshirt  fontSize="18px" style={{position:"absolute",justifyContent:"center"}}/>}>
            
          </Menu.Item>

          <Menu.Item onClick={(e)=>{ownProps.onMenuKeyChange(e.key);ActivateSetting();}} key="printSettings" style={{width:"100%",padding:"10px",justifyContent:"center",margin:"0"}} icon={<HiPhotograph  fontSize="18px" style={{position:"absolute",justifyContent:"center"}}/>}>
            
            </Menu.Item>

            <Menu.Item onClick={(e)=>{ownProps.onMenuKeyChange(e.key);ActivateSetting();}} key="englishText" style={{width:"100%",padding:"10px",justifyContent:"center",margin:"0"}} icon={<BiText  fontSize="18px" style={{position:"absolute",justifyContent:"center"}}/>}>
            
            </Menu.Item>

        </Menu>
    </div>  );}
 
export default LeftSideNavbar;


